import * as loadedConvict from '!val-loader!./convict-loader';
import { AppsyncAuthTypes } from '@thx/enums';

export interface IConvict {
  showBreakpointWidget: boolean;
  theme: string;
  appsyncUrl: string;
  appsyncApiKey: string;
  appsyncAuthType: AppsyncAuthTypes;
  appsyncUseRemote: boolean;
  appsyncUseMocks: boolean;
  javaChatBotAppRunnerUrl: string;
  b2bCdnUrl: string;
  homepageUrl: string;
}

export const convict = loadedConvict as IConvict;
